import React from 'react';
import { Alert, Container, Spinner } from 'react-bootstrap';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './AuthContext';

interface RequireAuthProps {
  children: React.ReactElement;
  permission?: string;
}

const LoadingState: React.FC = () => (
  <Container className="py-5 text-center">
    <Spinner animation="border" role="status" className="me-2" />
    Loading GCM
  </Container>
);

const AccessDenied: React.FC<{ permission: string }> = ({ permission }) => (
  <Container className="py-5">
    <Alert variant="warning">
      <Alert.Heading>Access denied</Alert.Heading>
      <p className="mb-0">
        Your account does not have the <code>{permission}</code> permission.
      </p>
    </Alert>
  </Container>
);

export const RequireAuth: React.FC<RequireAuthProps> = ({ children, permission }) => {
  const { user, isLoading, hasPermission } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return <LoadingState />;
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (permission && !hasPermission(permission)) {
    return <AccessDenied permission={permission} />;
  }

  return children;
};
